import moment from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { calcByte } from "utils/helpers/calcSize";
moment.extend(customParseFormat);

const regexes = {
  folder: new RegExp(/in:"([^"]*)"/),
  from: new RegExp(/from:"([^"]*)"/),
  to: new RegExp(/to:"([^"]*)"/),
  subject: new RegExp(/subject:"([^"]*)"/),
  larger: new RegExp(/larger:"([^"]*)"/),
  smaller: new RegExp(/smaller:"([^"]*)"/),
  before: new RegExp(/before:"([^"]*)"/),
  after: new RegExp(/after:"([^"]*)"/),
  attachment: new RegExp(/attachment:"([^"]*)"/)
};

const sizeRegex = new RegExp(/(\d*)([A-Z]*)/);
const parseBy = (key, query) => {
  const result = {};
  const inResult = query.match(regexes[key]);
  if (Array.isArray(inResult)) {
    const value = inResult[1];
    if (key === "smaller") {
      const val = value.match(sizeRegex);
      result["size_max"] = calcByte(val[1], val[2]);
    } else if (key === "larger") {
      const val = value.match(sizeRegex);
      result["size_min"] = calcByte(val[1], val[2]);
    } else result[key] = value;
  }

  return result;
};

const parseByFolder = query => {
  const result = {};
  const inResult = query.match(regexes.folder);
  if (Array.isArray(inResult)) {
    const folderName = inResult[1];
    if (folderName?.toLowerCase() === "__starred") {
      result.flagged = 1;
    } else {
      result.folder = folderName.split(":").join("/").trim();
    }

    return result;
  }
};

export const getSearch = query => {
  let search = query;
  Object.values(regexes).forEach(value => {
    search = search?.replace(value, "")?.trim();
  });
  return search || "";
};

const parser = (query, timestamp) => {
  if (!query || query === "null") {
    return {};
  }
  let search = query;

  const regValues = Object.values(regexes);

  regValues.forEach(value => {
    search = search.replace(value, "").trim();
  });

  const result = {
    ...parseByFolder(query),
    ...parseBy("from", query),
    ...parseBy("to", query),
    ...parseBy("subject", query),
    ...parseBy("larger", query),
    ...parseBy("smaller", query),
    ...parseBy("before", query),
    ...parseBy("after", query),
    ...parseBy("attachment", query),
    search: `${search}*`
  };

  if (timestamp) {
    if (result.after) {
      result.startdate = moment(result.after, "DD.MM.YYYY").format(
        "MM/DD/YYYY"
      );
      delete result.after;
    }

    if (result.before) {
      result.enddate = moment(result.before, "DD.MM.YYYY").format("MM/DD/YYYY");
      delete result.before;
    }
  }
  return result;
};

export default parser;
